import { render, staticRenderFns } from "./PartnerInfos.vue?vue&type=template&id=2869d27e&"
import script from "./PartnerInfos.vue?vue&type=script&lang=js&"
export * from "./PartnerInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports